import styles from './header.module.css';

export default ({ title }) => (
  <div>
    <div className={styles.header}>
      <div className={styles.bookshelf}/>
      <h1 className={styles.title}>{title}</h1>
      <div className={styles.typewriter}>
        <img src="/assets/typewriter.jpeg"/>
        <h1 className={styles.headline}>
          To learn about my finished projects, visit me at <a href="https://tricialynne.net">TriciaLynne.net</a>
        </h1>
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/header/Header.js